import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { config } from "./config";
import { captureAttributionFromUrl } from "./lib/attribution";
import { installGtmContainer, setAnalyticsDebug } from "./lib/analytics";
import "./styles/global.css"; // We'll create this file next

setAnalyticsDebug(config.analyticsDebug);
captureAttributionFromUrl();
installGtmContainer(config.gtmId);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
